import { store } from 'v3/data/store';
import { errorSlice } from '.';

export const showErrorDialog = (title: string, error?: any, actionClosedDialog: boolean = false) => {
  console.error(error);
  if (!window.navigator.onLine) {
    setErrorConnectionState();
  } else {
    const description = error?.response?.data?.details?.toString() ?? error?.response?.data?.message?.toString();
    store.dispatch(errorSlice.actions.showErrorDialog({ title, description, error: true, actionClosedDialog }));
  }
};

export const hideErrorDialog = () => {
  store.dispatch(errorSlice.actions.hideErrorDialog());
};

export const setErrorConnectionState = () => {
  const { error } = store.getState().error.connectionState;
  store.dispatch(errorSlice.actions.setErrorConnectionState(!error));
};

export const showBetaAccessErrorDialog = () => {
  store.dispatch(errorSlice.actions.showBetaAccessErrorDialog());
};
